import { useAuthenticator } from "@aws-amplify/ui-react";
import { Icon } from "@iconify/react";
import { Buffer } from "buffer";
import { Toast } from "primereact/toast";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertToBase64 } from "../../Utils";
import { getHourFileUrl, getTaskFileUrl } from "../../pages/Task/Utils";
import FileService from "../../services/FileService/FileService";
import "./FileUpload.css";

const FileUpload = ({ inputFileRef, classnames, files, setFiles, task, project_name, fileType, additionalParams }) => {
    const { t, i18n } = useTranslation();

    const toast = useRef();
    const [loading, setLoading] = useState(false);
    const fileService = new FileService();

    const { user } = useAuthenticator((context) => [context.user]);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const actualFile = e.target.files[0];

            setLoading(true);

            let newFileUrl = "";
            let newFile = {};

            let queryParams = {};

            if (fileType === "task_file") {
                newFileUrl = getTaskFileUrl(user, additionalParams?.task?.id, actualFile.name);
                newFile = {
                    name: actualFile.name,
                    url: newFileUrl,
                    client_id: additionalParams?.task?.client_id,
                    project_id: additionalParams?.task?.project_id,
                    process_id: additionalParams?.task?.process_id,
                    task_id: additionalParams?.task?.id,
                    project_name: additionalParams?.project_name,
                    task_name: additionalParams?.task?.title,
                    type: "task_file",
                };
                queryParams = {
                    type: "task_file",
                    client_id: additionalParams?.task?.client_id,
                    project_id: additionalParams?.task?.project_id,
                    process_id: additionalParams?.task?.process_id,
                    task_id: additionalParams?.task?.id,
                };
            } else {
                newFileUrl = getHourFileUrl(user, additionalParams?.hour?.id, actualFile.name);
                newFile = {
                    name: actualFile.name,
                    url: newFileUrl,
                    client_id: additionalParams?.hour?.client_id,
                    project_id: additionalParams?.hour?.project_id,
                    process_id: additionalParams?.hour?.service_id,
                    task_id: additionalParams?.hour?.task_id,
                    participant_id: additionalParams?.hour?.participant_id,
                    hour_id: additionalParams?.hour?.id,
                    type: "hour_file",
                };
                queryParams = {
                    type: "hour_file",
                    client_id: additionalParams?.hour?.client_id,
                    project_id: additionalParams?.hour?.project_id,
                    process_id: additionalParams?.hour?.service_id,
                    task_id: additionalParams?.hour?.task_id,
                    participant_id: additionalParams?.hour?.participant_id,
                    hour_id: additionalParams?.hour?.id,
                };
            }

            fileService
                // .createFile(fileType, task?.client_id, task?.project_id, task?.process_id, task?.id, newFile)
                .createFile(queryParams, newFile)
                .then((data) => {
                    convertToBase64(actualFile).then((convertedFile) => {
                        fetch(data?.url, {
                            method: "PUT",
                            body: new Buffer.from(convertedFile.substr(convertedFile.indexOf(",") + 1), "base64"),
                            headers: {
                                "Content-type": actualFile.type,
                            },
                        })
                            .then((response) => {
                                let newFiles = [];

                                if (files && files.length > 0) {
                                    newFiles = files;
                                }

                                newFiles.push(data);

                                setFiles(newFiles);
                                setLoading(false);
                            })
                            .catch((error) => {
                                console.error("Error:", error);
                                setLoading(false);
                            });
                    });
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    toast?.current?.show({ severity: "error", summary: t("label.error"), detail: error?.response?.data?.message, life: 5000 });
                });
        }
    };

    return (
        <div className="">
            <Toast ref={toast} />
            <div className={`custom-upload ${classnames}`}>
                <div className="custom-upload-container" onClick={() => inputFileRef?.current?.click()}>
                    <input accept="*" type="file" tabIndex="-1" style={{ display: "none" }} ref={inputFileRef} onChange={handleFileChange} />

                    <div className={`custom-upload-container-content ${classnames}`}>
                        {loading ? <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i> : <Icon icon="solar:cloud-upload-bold-duotone" className={`custom-upload-container-content-icon ${classnames}`} style={{ fontSize: "2.5rem", color: "var(--secondary-color-extra-light)" }} />}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FileUpload;
